import { jwtDecode, type JwtPayload } from 'jwt-decode'
import dayjs from 'dayjs'

class AuthenticationTokenService {
  private payload!: JwtPayload

  constructor(private jwtToken: string) {
    this.payload = jwtDecode(jwtToken)
  }

  public get token() {
    return this.jwtToken
  }

  public getPayload() {
    return this.payload
  }

  public isExpired() {
    if (!this.payload.exp) {
      return true
    }

    return dayjs(this.payload.exp * 1000)
      .subtract(5, 'minutes')
      .isBefore(dayjs())
  }
}

export default AuthenticationTokenService
